import { observable, action, makeObservable } from "mobx";
import { ReactNode } from "react";

export interface IProgressIndicatorModel {
  isOverlayVisible: boolean;
  isProgressVisible: boolean;
  isTopProgressBarVisible: boolean;
  showOverlay: () => void;
  hideOverlay: () => void;
  showProgress: () => void;
  showHideProgress: () => void;
  showTopProgressBarVisible: () => void;
  hideTopProgressBarVisible: () => void;
}

export class ProgressIndicatorModel implements IProgressIndicatorModel {
  renderComponent?: () => ReactNode;
  @observable isOverlayVisible: boolean = false;
  @observable isProgressVisible: boolean = false;
  @observable isTopProgressBarVisible: boolean = false;
  /**
   *
   */
  constructor() {
    makeObservable(this);
  }

  @action
  showOverlay = () => {
    this.isOverlayVisible = true;
  };

  @action
  hideOverlay = () => {
    this.isOverlayVisible = false;
  };

  @action
  showProgress = () => {
    this.isProgressVisible = true;
  };

  @action
  showHideProgress = () => {
    this.isProgressVisible = false;
  };

  showTopProgressBarVisible = () => {
    this.setIsTopProgressBarVisible(true);
  };

  hideTopProgressBarVisible = () => {
    this.setIsTopProgressBarVisible(false);
  };

  @action
  setIsTopProgressBarVisible = (val) => {
    this.isTopProgressBarVisible = val;
  };
}

const progressIndicatorModel = new ProgressIndicatorModel();

export default progressIndicatorModel;
